export default function Loader({ size = 30 }) {
    return (
        <div className="d-flex flex-row justify-content-center">
            <div className="spinner-border" role="status" style={{ width: `${size}px`, height: `${size}px` }}>
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}